import { handleActions } from "redux-actions";
import { PAGE_LAYOUT_FETCH } from "constants/action-types";

const initialState = {
    error: undefined,
    pageId: undefined,
};

export const pageLayout = handleActions(
    {
        [PAGE_LAYOUT_FETCH]: (state, { payload, error }) => {
            return {
                ...state,
                error,
                pageId: payload,
            };
        },
    },
    initialState,
);
